module.exports = __webpack_public_path__ + "media/react/features/event-creation-wizard/assets/templates/conference-55d0d60b1a4529ac04c79cf95115f1b4.png";